import { createAction } from 'redux-actions';

export const getInvestmentBalancesV2 = createAction('GET_INVESTMENT_BALANCES_V2');
export const getInvestmentBalancesV2Success = createAction('GET_INVESTMENT_BALANCES_V2_SUCCESS');
export const getInvestmentBalancesV2Failure = createAction('GET_INVESTMENT_BALANCES_V2_FAILURE');
